<script setup lang="ts">
const siteConfig = useSiteConfig()

useHead({
  htmlAttrs: {
    lang: 'en',
  },
  link: [
    { href: '/favicon.ico', rel: 'icon', type: 'image/x-icon' },
    { href: '/icon.png', rel: 'icon', sizes: '512x512', type: 'image/png' },
    { href: '/icon.png', rel: 'apple-touch-icon', sizes: '512x512', type: 'image/png' },
  ],
  meta: [
    { content: 'width=device-width, initial-scale=1', name: 'viewport' },
    { content: siteConfig.version, name: 'version' },
    { content: siteConfig.env, name: 'environment' },
  ],
  titleTemplate: titleChunk => {
    return titleChunk && titleChunk !== siteConfig.name ? `${titleChunk} - ${siteConfig.name}` : siteConfig.name
  },
})

useSeoMeta({
  description: siteConfig.description,
  ogDescription: siteConfig.description,
  ogImage: 'https://signalfire.games/images/sfg-icon.png',
  ogTitle: siteConfig.name,
  ogType: 'website',
  title: siteConfig.name,
  twitterCard: 'summary_large_image',
  twitterImage: 'https://signalfire.games/images/sfg-icon.png',
})

useSchemaOrg([
  defineWebSite({
    description: siteConfig.description,
    name: siteConfig.name,
  }),
  defineWebPage(),
])
</script>

<template>
  <UApp>
    <NuxtLayout>
      <NuxtPage/>
    </NuxtLayout>
  </UApp>
</template>
